import { createSvgIcon } from '@mui/material'

export const IconSort = createSvgIcon(
  <g>
    <path d="M3 11H15V13H3V11ZM3 18V16H21V18H3ZM3 6H9V8H3V6Z" fill="#0B0B0B" />
  </g>,
  'IconSort',
)
